module.exports = __webpack_public_path__ + "img/contentImg4.cec8275.webp";